export default {
  data() {
    return {
      isScrolled: false,
      scrollWidth: 0,
      actualWidth: 0,
      filterIsScrollable: false,
      filterIsScrolledLeft: false,
      filterIsScrolledRight: false,
      searchOffsetTop: 0,
      DOMBody: '',
    };
  },

  methods: {
    handleScroll() {
      if (this.searchOffsetTop < 0) {
        /**
         * @safety net
         */
        this.searchOffsetTop = window.innerWidth < 1024 ? 72 : 88;
      }

      const dpdwMenu = document.querySelector(
        '.con-vs-dropdown--menu.vs-dropdown-menu',
      );

      if (dpdwMenu) {
        if (this.isScrolled && dpdwMenu.style.position !== 'fixed') {
          dpdwMenu.style.position = 'fixed';
          dpdwMenu.style.top = '47px';
        } else if (!this.isScrolled && dpdwMenu.style.position === 'fixed') {
          dpdwMenu.style.position = 'absolute';
          dpdwMenu.style.top = '135px';
        }
      }

      this.isScrolled =
        (document.body.scrollTop || window.scrollY) >= this.searchOffsetTop;
      const body = document.body;
      const stickyClassName = 'sticky-search';

      if (this.isScrolled) {
        body.classList.add(stickyClassName);
      } else {
        body.classList.remove(stickyClassName);
      }
    },

    filterNavScrolled() {
      const navContent =
        this.$refs.filterNavSelectInput.getBoundingClientRect();
      const navWrapper = this.$refs.filterNav.getBoundingClientRect();
      const xFinal = Math.ceil(
        navWrapper.left - (navContent.width - navWrapper.width),
      );

      this.filterIsScrolledLeft = navContent.x < navWrapper.x;
      this.filterIsScrolledRight = navContent.x > xFinal;
    },
  },

  mounted() {
    if (this.isHomepage || this.isCompanyPage) {
      return;
    }

    this.DOMBody = document.querySelector('body');
    this.searchOffsetTop =
      (document.body.scrollTop || window.scrollY) +
      this.$el.getBoundingClientRect().top;
    window.addEventListener('scroll', this.handleScroll);
  },

  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
